module.exports = __webpack_public_path__ + "static/media/webpay.de0815e5.png";